import { useCallback, useEffect, useState } from "react";
import { UrlApi } from "../../../../../services/apirest";

const construirUrl = (activeTab, desde, hasta, sucursal) => {
  const rango = `${desde} 00:00:00/${hasta} 23:59:59/${sucursal}`;
  switch (activeTab) {
    case 0:
      return `/envasado_pedidos/xestado/${[245, 351]}/${rango}`;
    case 1:
      return `/envasado_pedidos/pendientes/${rango}`;
    case 2:
      return `/envasado_pedidos/xestado/${271}/${rango}`;
    case 3:
      return `/envasado_pedidos/pendientesfacturacion/${rango}`;
    default:
      return `/envasado_pedidos/pendientes/${rango}`;
  }
};

// Trae los pedidos de la pestaña activa y expone un `refetch` manual,
// pensado para combinarse con useAutoRefresh (polling) y con el botón
// de refresco manual del encabezado.
const usePedidosData = (activeTab, desde, hasta) => {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchPedidos = useCallback(async () => {
    setLoading(true);
    try {
      const sucursal = localStorage.getItem("suc_auth").split(",");
      const url = construirUrl(activeTab, desde, hasta, sucursal);
      const response = await fetch(UrlApi + url);
      if (!response.ok) throw new Error("Error al obtener pedidos");
      const data = await response.json();
      setPedidos(Array.isArray(data) ? data : []);
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Error obteniendo pedidos:", error);
    } finally {
      setLoading(false);
    }
  }, [activeTab, desde, hasta]);

  useEffect(() => {
    fetchPedidos();
  }, [fetchPedidos]);

  return { pedidos, loading, lastUpdated, refetch: fetchPedidos };
};

export default usePedidosData;
